/*eslint-disable*/
import { useNavigate } from "react-router-dom";
import settings from "../../../configs/settings";
import { Box, Tooltip, IconButton, Grid, Paper, TextField, Typography, } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useContext, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import Message from "../../../project/utils/Message";
import Item from "../../utils/Item";
import { formatMoney } from "../../utils/utils"

//
// ################################################################################
//
const Cobranza = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const { cobranzasRows, totalesCobranza } = useContext(GestionAtencionContext);

  const { totalGA, totalRecargo, totalDescuento, totalCobrado, totalPendienteCobro } =
    totalesCobranza;

  const tableColumns = [
    {
      field: "cobranzaCodigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaCodigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cobranzaFechaCreacion",
      headerName: "F.Creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaFechaCreacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cobranzaImporteTotalCobrado",
      headerName: "Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = (params.row.cobranzaImporteTotalCobrado + params.row.cobranzaImporteTotalRecargo).toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cobranzaImporteTotalDescuento",
      headerName: "Descuento",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaImporteTotalDescuento.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cobranzaImporteTotalRecargo",
      headerName: "Recargo",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaImporteTotalRecargo.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cobranzaEstado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaEstado;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "facturado",
      headerName: "Facturado?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = "";
        if (!params.row.cobranzaEmitirFactura) {
          _val = "--";
        } else {
          _val = params.row.cobranzaNumeroFactura ? "Sí" : "No";
        };
        return _val;
      },
    },
    {
      field: "cobranzaNumeroFactura",
      headerName: "Nro.Factura",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaNumeroFactura;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cobranzaOdooUpdated",
      headerName: "Odoo?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaOdooUpdated ? "" : "No";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cobranzaUsuario",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaUsuario;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cobranzaArea",
      headerName: "Sucursal",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cobranzaArea;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Ver cobranza",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver cobranza">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => obtieneCobranza(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const obtieneCobranza = (parRow, parAction) => {
    const _url = `/cobranza/${parRow.id}/${parAction}`
    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box>
        <Paper elevation={3} sx={{ m: 1, p: 2 }}>
          <Grid container>
            <Grid item xs={12}>
              <DataGrid
                rows={cobranzasRows}
                columns={tableColumns}
                {...tableOptions}
              />
            </Grid>
          </Grid>

          <Box sx={{ mt: 3, mb: 1 }}>
            <Grid container spacing={1} justifyContent="center" >
              <Item label="Total de lista" value={formatMoney(totalGA)} valueColor="info.main" valueAlign="right" xl={2} />
              <Item label="Total de Recargos (+)" value={formatMoney(totalRecargo)} valueColor="info.main" valueAlign="right" xl={2} />
              <Item label="Total de Descuentos (-)" value={formatMoney(totalDescuento)} valueColor="info.main" valueAlign="right" xl={2} />
              <Item label="Total de Cobrado (-)" value={formatMoney(totalCobrado)} valueColor="info.main" valueAlign="right" xl={2} />
              <Item label="Total Pendiente de Cobro" value={formatMoney(totalPendienteCobro)} valueColor="info.main" valueAlign="right" xl={2} />
            </Grid>
          </Box>
        </Paper>
      </Box>

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};

export default Cobranza;
